import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isS3Key, resolveS3Url } from "../utils/s3";

// Resolves a stored image/file value (full URL or S3 key) into a displayable URL.
const useS3Url = (value) => {
  const accessToken = useSelector((state) => state.user.accessToken);
  const [url, setUrl] = useState(isS3Key(value) ? "" : value);

  useEffect(() => {
    if (!isS3Key(value)) {
      setUrl(value);
      return;
    }
    let cancelled = false;
    setUrl("");
    resolveS3Url(value, accessToken)
      .then((resolved) => !cancelled && setUrl(resolved))
      .catch((error) => console.error("Failed to resolve S3 url:", error));
    return () => {
      cancelled = true;
    };
  }, [value, accessToken]);

  return url;
};

export default useS3Url;
